import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * SEO Component - Dynamic page head management using React Helmet
 *
 * This component allows you to set page-specific meta tags, titles, and canonical URLs
 * for better SEO on each page of your React application.
 *
 * Usage Example:
 * <SEO
 *   title="Spare Parts - Category"
 *   description="Browse our wide range of spare parts..."
 *   keywords="spare parts, auto parts"
 *   canonical="https://asiapartsouq.com/category"
 * />
 */

const SEO = ({
  title = "Asia Parts - Quality Spare Parts & Engineering Solutions",
  description = "Asia Parts is your trusted supplier of quality spare parts, engineering components,building materials and rental equipment.",
  keywords = "spare parts, engineering components, auto parts, equipment rental",
  canonical = "https://asiapartsouq.com/",
  ogImage = "https://asiapartsouq.com/images/og-image.jpg",
  ogUrl = "https://asiapartsouq.com/",
  ogType = "website",
  author = "Asia Parts",
  twitterHandle = "@asiaparts",
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />

      {/* Canonical URL - Prevents duplicate content issues */}
      <link rel="canonical" href={canonical} />

      {/* Open Graph Tags - For social media sharing */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:site_name" content="Asia Parts" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:creator" content={twitterHandle} />
    </Helmet>
  );
};

export default SEO;
